module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovateli_ovtkz.0154d9d2.pdf";